import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styled from '@emotion/styled';
import { semantic_colors, text_styles } from '../../foundation';

export interface HelpTextContent {
  description?: ReactNode;
  content?: ReactNode;
}
export interface HelpTextProps {
  className?: string;
  title?: ReactNode;
  contents: HelpTextContent[];
}

export const HelpText: React.FC<HelpTextProps> = ({ className, title, contents }) => (
  <StyledTooltipHelpText className={classNames('pds-help-text', className)}>
    {title && <div className='title'>{title}</div>}
    <div className='contents'>
      {contents.map(({ description, content }, index) => (
        <div className='content' key={index}>
          {description && <div className='subtitle'>{description}</div>}
          {content && <div className='text'>{content}</div>}
        </div>
      ))}
    </div>
  </StyledTooltipHelpText>
);

const StyledTooltipHelpText = styled.div`
  padding: 16px 20px;
  width: 280px;
  color: ${semantic_colors.content.primary};

  .content {
    margin: 0 0 8px;
    ${text_styles.Body_13_Regular};
    white-space: pre-wrap;

    &:last-of-type {
      margin: 0;
    }
  }
  .title {
    margin: 0 0 8px;
    ${text_styles.Body_15_SemiBold};
  }
`;
